import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { NOTIFICATIONS_COMPONENTS_I18N_KEY } from "./constants";
export default /*#__PURE__*/_defineProperty({}, NOTIFICATIONS_COMPONENTS_I18N_KEY, {
  NOTIFICATIONS_LABEL: 'Notificaciones',
  NOTIFICATIONS_TITLE: 'Lo último en Crehana',
  NOTIFICATIONS_COURSES: 'Cursos',
  NOTIFICATIONS_COURSE_DETAIL: 'Ver detalle',
  NOTIFICATIONS_FEATURES: 'Updates',
  NOTIFICATIONS_ERROR: 'Ocurrió un error, inténtalo de nuevo más tarde.',
  NOTIFICATIONS_RETRY: 'Reintentar',
  NOTIFICATIONS_EMPTY: '¡Pronto descubrirás todas las novedades que tenemos para ti!'
});